<template>
  <div>
    <el-form label-position="top" :model="compcase" ref="compcase" class="compcase-form">
      <h4>Case Details</h4>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="type">
            <select
              v-model="compcase.type"
              placeholder="Select Type"
              disabled
              :class="
                compcase.type !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
              "
            >
              <option disabled :value="undefined" selected>Select Type</option>
              <option
                v-for="{ type, name } in compCasesTypes"
                :label="name"
                :key="type"
                :value="type"
              >
                {{ name }}
              </option>
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="scene">
            <select
              v-model="compcase.scene"
              placeholder="Select Scene"
              disabled
              :class="
                compcase.scene !== undefined
                  ? 'tw-font-medium tw-text-black'
                  : 'tw-font-normal tw-text-black'
              "
              >>
              <option disabled :value="undefined" selected>Select Scene</option>
              <option v-for="{ type, name } in sceneType" :label="name" :key="type" :value="type">
                {{ name }}
              </option>
            </select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="meta.competition._id">
            <input :value="compcase.meta.competition.name" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="round">
            <input :value="formatRoundName()" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item prop="meta.matchId">
            <input :value="formatMatchName()" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="meta.teamId">
            <input :value="compcase.team && compcase.team.name" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="memberId">
            <input :value="formatMemberName()" disabled />
          </el-form-item>
        </el-col>
      </el-row>
      <hr />
      <h4>Charges</h4>
      <el-row :gutter="10" class="mb-2">
        <el-col>
          <data-tables
            :data="compcase.charges"
            :table-props="{ border: true }"
            layout="table"
            class="data-table"
          >
            <el-table-column label="Type" prop="name" width="300"> </el-table-column>
            <el-table-column label="Description" prop="description" width="300"> </el-table-column>
            <el-table-column label="Recommended Grading" prop="recommendedGrading" width="200">
            </el-table-column>
          </data-tables>
        </el-col>
      </el-row>
      <hr />
      <h4>Notes</h4>
      <el-row>
        <el-timeline>
          <el-timeline-item
            v-for="(item, index) in compcase.notes"
            :key="index"
            color="#098255"
            :timestamp="item.createdAt.toString()"
            :hide-timestamp="true"
          >
            {{ item.note }}
            <br />
            <!-- element ui built in classes -->
            <span class="el-timeline-item__timestamp is-bottom"
              >{{ formatTimestamp(item.createdAt) }} - {{ item.createdBy.firstName }}
              {{ item.createdBy.lastName || "" }}</span
            >
          </el-timeline-item>
        </el-timeline>
      </el-row>
      <el-row>
        <el-col>
          <el-col :span="24" style="text-align: right">
            <el-button type="" size="medium" @click="cancel">Back</el-button>
          </el-col>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import _ from "lodash";
import { caseCharges, compCasesTypes } from "../../utils/constants";

export default {
  components: {},
  data() {
    return {
      caseCharges,
      tribunalStatus: ["Pending", "Charge Issued", "No Further Action Required"],
      compCasesTypes,
      sceneType: [
        { type: 1, name: "Match" },
        { type: 2, name: "Other" }
      ],
      chargeGradings: [1, 2, 3, 4, 5],
      competitions: [],
      competition: undefined,
      round: undefined,
      matches: [],
      members: [],
      compcase: {
        type: 1,
        scene: 1,
        memberId: "",
        charges: [],
        note: "",
        status: "Pending",
        meta: {
          competition: {
            _id: undefined,
            name: undefined
          },
          matchId: undefined,
          teamId: undefined
        }
      }
    };
  },
  computed: {
    rounds() {
      if (this.matches && this.matches.length) {
        return _.chain(this.matches)
          .map("round")
          .orderBy(["type", "number"], ["desc", "asc"])
          .sortedUniqBy("displayName")
          .value();
      }
      return [];
    }
  },
  mounted() {
    const { id } = this.$route.params;
    this.$store.commit("root/loading", true);
    this.$http
      .get(`/nrl/api/v1/admin/competition-cases/${id}`)
      .then(res => {
        this.compcase = res.data.data;
        this.$store.commit("root/loading", false);
      })
      .catch(() => {
        this.$store.commit("root/loading", false);
        this.$customError();
      });
  },
  methods: {
    cancel() {
      this.$router.push({
        name: "competition-cases"
      });
    },
    nameFormatter(item) {
      if (item.profile) { return `${_.get(item, "profile.firstName")} ${_.get(item, "profile.lastName")}`; }
      return `${_.get(item, "firstName")} ${_.get(item, "lastName")}`;
    },
    formatTimestamp(time) {
      return this.dayjs(time).format("MMMM Do YYYY, h:mm:ss a");
    },
    formatMemberName() {
      if (this.compcase.member) {
        return `${_.get(this.compcase.member, "profile.firstName")} ${_.get(
          this.compcase.member,
          "profile.lastName"
        )}`;
      }
      return "N/A";
    },
    formatMatchName() {
      if (this.compcase.match) {
        const home =
          (this.compcase.match.homeTeam && this.compcase.match.homeTeam.name) ||
          (this.compcase.match.meta.isBye ? "BYE" : "NA");
        const away =
          (this.compcase.match.awayTeam && this.compcase.match.awayTeam.name) ||
          (this.compcase.match.meta.isBye ? "BYE" : "NA");
        return `${home} vs ${away}`;
      }
      return "N/A";
    },
    formatRoundName() {
      if (this.compcase.match) {
        return _.get(this.compcase.match, "round.displayName");
      }
      return "N/A";
    },
    resetFields() {
      this.round = undefined;
      this.compcase.meta.matchId = undefined;
      this.compcase.meta.teamId = undefined;
      this.compcase.memberId = undefined;
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-control {
  text-align: right;
}
.el-input,
.el-select {
  width: 100%;
}

select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 8px;
  @apply tw-w-full tw-px-2 tw-text-sm tw-placeholder-gray-800 focus:tw-outline-none tw-text-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9;
}
.input {
  @apply tw-w-full tw-px-2 tw-text-sm tw-text-gray-800 tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-shadow-none focus:tw-outline-none tw-h-9;
}
</style>
